 
/** 这个混入是为了测试一些渠道 如 360 是否通过白名单来限制我们的落地页域名 做测试用 现在已废弃 */
import axios from 'axios'
export default {
  data () {
    return {
      landingTestChannelUrl: '',
      channels: []
    }
  },
  mounted () {
    this.getConfig()
  },
  methods: {
    async getConfig () {
      const res = await axios.get(process.env.VUE_APP_STATIC_CONFIG)
      if (res.status === 200 && res.data) {
        const { landingTestChannel, landingTestChannelUrl } = res.data
        this.landingTestChannelUrl = landingTestChannelUrl
        if (landingTestChannel) {
          this.channels = landingTestChannel.split(',')
        }
      }
    }
  }
}